module.exports = __webpack_public_path__ + "static/img/A (13).55366965.png";